<template>
  <div class="bg-[#23242A] text-white app-header p-3" id="content_screen">
    <div :class="'px-3 pt-3  pb-28 flex content-main ' + (action.component ? ' half-it gap-5' : 'gap-5')">
      <div class="custom-full overflow-auto h-screen pb-[100px]">
        <Nav/>
        <div class="bg-[#2B2C32] rounded-lg px-[16px] max-w-full py-[16px]">
          <div class="flex justify-between mb-5 h-[40px]">
            <h2 class="text-xl font-semibold text-theme-878686">Reason Code</h2>
            <mdicon @click="addUpdate({ component: 'Add', data: {}})" v-if="!action.component" size="32" name="plus" class="text-white bg-theme-green hover:bg-theme-darkgreen py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer"/>
          </div>
          <List :selectedCallback="selectedItem" :clearComponent="clearComponent" :iscomponentactive="action.component ? true : false"/>
        </div>
      </div>
  
      <div :class="'w-full hidden-component  overflow-auto h-screen pb-[100px]'" v-if="action.component" >
        <component :is="action.component" :item="action.data" :clearComponent="clearComponent"></component>
      </div>

    </div>
  </div>
</template>


<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import Nav from '@/views/Products/Promotions/Nav.vue';
import List from '@/views/Products/ReasonCode/List.vue';
import Add from '@/views/Products/ReasonCode/Add.vue';
import Update from '@/views/Products/ReasonCode/Update.vue';

  export default defineComponent({
  name: "ProductReasonCode",
  components: {
    Nav,
    List,
    Add,
    Update,
  },

  setup() {
    const action = ref<object>({
      component: '',
      data: {},
    });
    return {
      action,
    };
  },

   watch: {
    'vg_selectedLocation'(val) {
      this.clearComponent();
    },
  },

  computed: {
    ...mapGetters({
     vg_selectedLocation: 'location/selected'
    }),
  },

  mounted() {
  },

  beforeDestroy() {
   
  },
 
  methods: {
    /**
     * Clear action
     */
    clearComponent() {
      this.action = {
        component: '',
        data: {},
      };
      let activeItem = document.getElementsByClassName('active-row');
      if(activeItem.length > 0){
        activeItem[0].classList.remove("active-row");
      }
    },

    /**
     * Change add / update component
     */
    addUpdate(val: any) {
      this.action = val;
    },

    /**
     * Capture selected item
     */
    selectedItem(item) {
      this.addUpdate({
        component: 'Update', 
        data: item
      })
    },

    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>